<template>
    <div class="info_detail block_detail">
        <ul v-if="checkBlock()">
            <li class="block_list" v-for="(block,index) in blockDataKey" :key="`block${index}`" v-if="checkData(block)">
                <h3 class="sub_title_s">{{ returnType(block) }}</h3>
                <div class="sub_content_s">{{ blockData[block] }}</div>
            </li>
        </ul>
        <div v-else>
            {{ $t('block_data_error') }}
        </div>
    </div>

</template>

<script>
import util from "@/mixins/util";

export default {
    name: "BlockChainComponent",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        blockData: '',
    },
    data() {
        return {
            blockDataKey: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        if (!util.isEmpty(this.blockData)) {
            this.blockDataKey = Object.keys(this.blockData)
        }
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        checkData(data) {
            if (data === 'imageUrl' || data === 'nftOwners') {
                return false
            }
            if (util.isEmpty(this.blockData[data])) {
                return false
            }
            return true
        },
        returnType(type) {
            return type.charAt(0).toUpperCase() + type.slice(1);
        },
        checkBlock() {
            return !util.isEmpty(this.blockData)
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>